import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import imgSplitReducer from './imgSplitSlice';
import websocketReducer from "./websocketSlice";
import { websocketMiddleware } from "./websocketMiddleware";

const store = configureStore({
    reducer: {
        auth: authReducer,
        imgSplit: imgSplitReducer,
        websocket: websocketReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['imgSplit/setFile'],
                ignoredPaths: ['imgSplit.file'],
            },
        }).concat(websocketMiddleware),
});

export default store;